import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export interface State {
  selectedGuest?: SelectedGuest;
}

export interface SelectedGuest {
  purchase: core.PastPurchase;
  ticketGroup: core.TicketGroup;
}

export const initialState: State = {
  selectedGuest: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.GUEST_LIST_SET_SELECTED_GUEST: {
      return {
        ...state,
        selectedGuest: payload,
      };
    }
    case AppConstants.GUEST_LIST_CLEAR_SELECTED_GUEST: {
      return {
        ...state,
        selectedGuest: undefined,
      };
    }
    default:
      return state;
  }
}
